(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){
(function(a,b){if("function"==typeof define&&define.amd)define([],b);else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Depricated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(b,c,d){var e=new XMLHttpRequest;e.open("GET",b),e.responseType="blob",e.onload=function(){a(e.response,c,d)},e.onerror=function(){console.error("could not download file")},e.send()}function d(a){var b=new XMLHttpRequest;return b.open("HEAD",a,!1),b.send(),200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.saveAs||"object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(a,b,d,e){if(e=e||open("","_blank"),e&&(e.document.title=e.document.body.innerText="downloading..."),"string"==typeof a)return c(a,b,d);var g="application/octet-stream"===a.type,h=/constructor/i.test(f.HTMLElement)||f.safari,i=/CriOS\/[\d]+/.test(navigator.userAgent);if((i||g&&h)&&"object"==typeof FileReader){var j=new FileReader;j.onloadend=function(){var a=j.result;a=i?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),e?e.location.href=a:location=a,e=null},j.readAsDataURL(a)}else{var k=f.URL||f.webkitURL,l=k.createObjectURL(a);e?e.location=l:location.href=l,e=null,setTimeout(function(){k.revokeObjectURL(l)},4E4)}};f.saveAs=a.saveAs=a,"undefined"!=typeof module&&(module.exports=a)});


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(require,module,exports){
"use strict";

require("file-saver");

document.addEventListener('DOMContentLoaded', function (e) {
  var isAdvancedUpload = function () {
    var div = document.createElement('div');
    return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
  }(); // applying the effect for every form


  var forms = document.querySelectorAll('.box');
  Array.prototype.forEach.call(forms, function (form) {
    var input = form.querySelector('input[type="file"]'),
        filename = form.querySelector('.box__filename'),
        errorMsg = form.querySelector('.box__error span'),
        progress = document.querySelector('.box__progress'),
        restart = form.querySelectorAll('.box__restart'),
        origMsg = form.querySelector('.box__origmsg'),
        droppedFiles = false,
        encryptButton = form.querySelector('button[name=encrypt]'),
        decryptButton = form.querySelector('button[name=decrypt]'),
        passInput = form.querySelector('input[name=password]'),
        showFiles = function showFiles(files) {
      // filename.textContent = files.length > 1 ? ( input.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', files.length ) : files[ 0 ].name;
      origMsg.classList.add('hide');
      filename.textContent = files[0].name;
      filename.classList.remove('hide');
    }; // automatically submit the form on file select


    input.addEventListener('change', function (e) {
      showFiles(e.target.files);
      droppedFiles = [e.target.files[0]];
    }); // drag&drop files if the feature is available

    if (isAdvancedUpload) {
      form.classList.add('has-advanced-upload'); // letting the CSS part to know drag&drop is supported by the browser

      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (event) {
        form.addEventListener(event, function (e) {
          // preventing the unwanted behaviours
          e.preventDefault();
          e.stopPropagation();
        });
      });
      ['dragover', 'dragenter'].forEach(function (event) {
        form.addEventListener(event, function () {
          form.classList.add('is-dragover');
        });
      });
      ['dragleave', 'dragend', 'drop'].forEach(function (event) {
        form.addEventListener(event, function () {
          form.classList.remove('is-dragover');
        });
      });
      form.addEventListener('drop', function (e) {
        // droppedFiles = e.dataTransfer.files; // the files that were dropped
        droppedFiles = [e.dataTransfer.files[0]];
        showFiles(droppedFiles);
      });
    } // if the form was submitted


    form.addEventListener('submit', function (e) {
      e.preventDefault();
    });
    encryptButton.addEventListener('click', function () {
      // preventing the duplicate submissions if the current one is in progress
      if (form.classList.contains('is-busy')) return false;

      if (droppedFiles) {
        form.classList.add('is-busy');
        form.classList.remove('is-error');
        encryptLocal(droppedFiles[0], passInput.value, function (status, arg) {
          if (status === 'progress') {
            progress.textContent = 'Encrypting File - ' + arg + '%';
          } else if (status === 'end') {
            progress.textContent = 'Encryption Complete!';
            form.classList.remove('is-busy');
            form.classList.add('is-success');
          } else if (status === 'error') {
            errorMsg.textContent = arg;
            form.classList.remove('is-busy');
            form.classList.add('is-error');
          }
        });
      }
    });
    decryptButton.addEventListener('click', function () {
      // preventing the duplicate submissions if the current one is in progress
      if (form.classList.contains('is-busy')) return false;

      if (droppedFiles) {
        form.classList.add('is-busy');
        form.classList.remove('is-error');
        decryptLocal(droppedFiles[0], passInput.value, function (status, arg) {
          if (status === 'progress') {
            progress.textContent = 'Decrypting File - ' + arg + '%';
          } else if (status === 'end') {
            progress.textContent = 'Decryption Complete!';
            form.classList.remove('is-busy');
            form.classList.add('is-success');
          } else if (status === 'error') {
            errorMsg.textContent = arg;
            form.classList.remove('is-busy');
            form.classList.add('is-error');
          }
        });
      }
    }); // restart the form if has a state of error/success

    Array.prototype.forEach.call(restart, function (entry) {
      entry.addEventListener('click', function (e) {
        e.preventDefault();
        origMsg.classList.remove('hide');
        filename.classList.add('hide');
        form.classList.remove('is-error', 'is-success');
        form.reset();
        droppedFiles = undefined;
      });
    }); // Firefox focus bug fix for file input

    input.addEventListener('focus', function () {
      input.classList.add('has-focus');
    });
    input.addEventListener('blur', function () {
      input.classList.remove('has-focus');
    });
  });
});

},{"file-saver":1}]},{},[2]);
